import React from 'react';

import { Header } from 'shared/components/sections/header/header';

interface ILayoutProps {
  children: React.ReactNode;
  title?: React.ReactNode | string;
  isGuestMode?: boolean;
  className?: string;
}

const DesktopLayout = ({ children, title, isGuestMode, className = '' }: ILayoutProps) => (
  <div
    className={`relative mx-auto flex h-full min-h-[100vh] w-full max-w-screen-hd flex-col px-4 xlg:px-16 ${className ?? ''}`}
  >
    <Header title={title} isGuestMode={isGuestMode} className="mb-12 pt-8" />
    {children}
  </div>
);

export default DesktopLayout;
